import { memo } from "react";
import { TransferRuleDirection } from "@common/types/transactionRule";
import { RuleDetailsRowData } from "../utils/historyRuleDetailsRows";
import { RuleDetailsConditionsCell } from "./RuleDetailsConditionsCell";

export const RuleDetailsToCell = memo(
    ({ row }: { row: { original: RuleDetailsRowData } }) => (
        <RuleDetailsConditionsCell
            row={row}
            transferDirection={TransferRuleDirection.TO}
            markerClassName="to"
        />
    ),
);

RuleDetailsToCell.displayName = "RuleDetailsToCell";
